import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Row, Col, Button } from "antd";
import { useTranslation } from "react-i18next";

const PaymentCancel = () => {
  const { t } = useTranslation();
  return (
    <Row className="hp-bg-color-primary-4 hp-bg-color-dark-90 hp-text-center">
      <Col className="hp-error-content hp-py-32" span={24}>
        <Row className="hp-h-100" align="middle" justify="center">
          <Col>
            <h2 className="h1 hp-mb-sm-0 hp-mb-16">
              {" "}
              {t("subscription.paymentFailed")}
            </h2>
            <p className="hp-mb-32 hp-p1-body">
              {" "}
              {t("subscription.paymentFailedInfo")}
            </p>

            <Link to="/profile/subscription">
              <Button type="primary">{t("subscription.goBack")}</Button>
            </Link>
          </Col>
        </Row>
      </Col>

      <Col span={24} className="hp-py-24">
        <p className="hp-mb-0 hp-badge-text">
          {t("subscription.copyRight")} {new Date().getFullYear()}{" "}
          {t("subscription.netraga")}
        </p>
      </Col>
    </Row>
  );
};

export default withRouter(PaymentCancel);
